import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PopLMSSection from '../components/PopLMSSection';
import { ArrowLeft } from 'lucide-react';

const PopLMSPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: '#0f172a', minHeight: '100vh', paddingTop: '20px' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', marginBottom: '20px' }}>
        <button 
          onClick={() => navigate('/pop-dashboard')}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            background: 'none', 
            border: 'none', 
            color: '#94a3b8', 
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          <ArrowLeft size={16} /> Back to Dashboard
        </button>
      </div>
      <PopLMSSection initialCourseId={courseId} />
    </div>
  );
};

export default PopLMSPage;
